import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { useMemo } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
export var useIconList = function useIconList(_ref) {
  var icons = _ref.icons,
    iconTypeList = _ref.iconTypeList,
    shouldUnselect = _ref.shouldUnselect;
  return useMemo(function () {
    return icons.reduce(function (acc, icon) {
      if (!icon || !icon.iconMark) {
        return acc;
      }
      if (shouldUnselect && icon.isActive && editorExperiment('platform_editor_controls', 'variant1') && fg('platform_editor_controls_patch_7')) {
        icon.isActive = false;
      }
      var isIconSingleButton = iconTypeList.includes(icon.iconMark);
      if (isIconSingleButton) {
        return {
          dropdownItems: acc.dropdownItems,
          singleItems: [].concat(_toConsumableArray(acc.singleItems), [icon])
        };
      }
      return {
        dropdownItems: [].concat(_toConsumableArray(acc.dropdownItems), [icon]),
        singleItems: acc.singleItems
      };
    }, {
      dropdownItems: [],
      singleItems: []
    });
  }, [icons, shouldUnselect, iconTypeList]);
};